import { render, staticRenderFns } from "./CalendarDetail.vue?vue&type=template&id=3d5a6842"
import script from "./CalendarDetail.vue?vue&type=script&lang=ts"
export * from "./CalendarDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports